import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

export default function LogoutHandler({ logout }) {
  const navigate = useNavigate();

  useEffect(() => {
    logout();
    navigate("/"); // Программная навигация
  }, [logout, navigate]);

  return null;
}
